import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import { Box } from "@cloudscape-design/components";

interface HelpPanelContent {
  header: string;
  content: ReactNode;
}

interface HelpPanelContextType {
  helpPanelContent: HelpPanelContent;
  setHelpPanelContent: (content: HelpPanelContent) => void;
  isHelpPanelOpen: boolean;
  setIsHelpPanelOpen: Dispatch<SetStateAction<boolean>>;
}

export const helpPanelDefaultContent: HelpPanelContent = {
  header: "Overview",
  content: <Box>Coming Soon...</Box>,
};

const HelpPanelContext = createContext<HelpPanelContextType | undefined>(
  undefined
);

export const HelpPanelProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [helpPanelContent, setHelpPanelContent] =
    useState<HelpPanelContent>(helpPanelDefaultContent);

  const [isHelpPanelOpen, setIsHelpPanelOpen] = useState(false);

  return (
    <HelpPanelContext.Provider
      value={{
        helpPanelContent,
        setHelpPanelContent,
        isHelpPanelOpen,
        setIsHelpPanelOpen,
      }}
    >
      {children}
    </HelpPanelContext.Provider>
  );
};

export const useHelpPanel = () => {
  const context = useContext(HelpPanelContext);

  if (!context) {
    throw new Error(
      "useHelpPanel must be used within a HelpPanelProvider."
    );
  }

  return context;
};